import React, { FC } from 'react';
import styled from '@emotion/styled';
import { BodyTextSmall, HeadingText10 } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';

interface ProviderDetailsModalContentProps {
    Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    heading: string;
    value: string;
}

export const ProviderDetailsModalContent: FC<ProviderDetailsModalContentProps> = ({
    Icon,
    heading,
    value,
}) => {
    return (
        <Content>
            <InformationTitleContainer>
                <Icon height={20} width={20} />
                <HeadingText10 marginLeft={8} marginBottom={0}>
                    {heading}
                </HeadingText10>
            </InformationTitleContainer>
            <BodyTextSmall>{value}</BodyTextSmall>
        </Content>
    );
};

const Content = styled.div({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderTop: `2px solid ${colors.gray05}`,
    paddingTop: 12,
    paddingBottom: 12,
});

const InformationTitleContainer = styled.div({
    display: 'flex',
    flexDirection: 'row',
    minWidth: 150,
});
